// extracted by mini-css-extract-plugin
export default {"pagenation":"Pagination_pagenation__Na+q2","pageButton":"Pagination_pageButton__Gkn7F","active":"Pagination_active__0B7ND","arrowButton":"Pagination_arrowButton__zAm-0"};